import type { ReactNode } from 'react';

import { AppRoutes } from '@/constants';
import { usePermission } from '@/hooks';
import { navigate } from '@/providers';
import { PermissionMetadata } from '@/utils';

import { Loading } from '@/components/common';

interface IProtectedRoute {
  permissions: PermissionMetadata[];
  children: ReactNode;
}

// Route guard. Renders children only if the current user has the required permission.
// Otherwise redirect to Forbidden page.
export const ProtectedRoute = ({ permissions, children }: IProtectedRoute) => {
  const { isGranted, isLoading } = usePermission();

  if (isLoading) return <Loading fullScreen />;
  if (permissions.every((permission) => !isGranted(permission))) {
    navigate(AppRoutes.FORBIDDEN);
    return null;
  }
  return <>{children}</>;
};
